const DEFAULT_LEGAL_ROUTES = {
    privacyPolicy: '/privacy-policy/',
    termsAndConditions: '/terms-and-conditions/',
    cookiePolicy: '/cookie-policy/',
    complaintPolicy: '/complaints-policy/',
    cryptoRiskDisclosures: '/cryptocurrency-risk-disclosures/',
}

const NEURONEXT_LEGAL_ROUTES = {
    privacyPolicy: 'https://neuronext.pl/privacy-policy/',
    termsAndConditions: 'https://neuronext.pl/terms/',
    complaintPolicy: 'https://neuronext.pl/complaints/',
}

export const footerConfig = {
    default: {
        legalLinks: [
            {
                title: "footer.privacy_policy",
                href: DEFAULT_LEGAL_ROUTES.privacyPolicy,
            },
            {
                title: "footer.terms_conditions",
                href: DEFAULT_LEGAL_ROUTES.termsAndConditions,
            },
            {
                title: "footer.cookie_policy",
                href: DEFAULT_LEGAL_ROUTES.cookiePolicy,
            },
            {
                title: "footer.complaints_policy",
                href: DEFAULT_LEGAL_ROUTES.complaintPolicy,
            },
            {
                title: "footer.cryptocurrency_risk_disclosures",
                href: DEFAULT_LEGAL_ROUTES.cryptoRiskDisclosures,
            },
        ],
        copyright: 'footer.copyright',
        footerItems: [
            'footer.Banxe_LTD_is',
            'footer.Banxe_is_a',
            'footer.Tompay_LTD_is',
            'footer.The_services_offered',
            'footer.Cryptocurrency_services',
        ],
    },
    neuronext: {
        legalLinks: [
            {
                title: "footer.privacy_policy",
                href: NEURONEXT_LEGAL_ROUTES.privacyPolicy,
            },
            {
                title: "footer.terms_conditions",
                href: NEURONEXT_LEGAL_ROUTES.termsAndConditions,
            },
            {
                title: "footer.complaints_policy",
                href: NEURONEXT_LEGAL_ROUTES.complaintPolicy,
            },
        ],
        copyright: 'neuronext.copyright',
        footerItems: [
            'neuronext.footer_description',
        ],
    },
} as const
